import { Theme } from '@mui/material/styles'

const muiCheckbox = (theme: Theme) => {
  return {
    defaultProps: {
      disableRipple: true,
      disableFocusRipple: true,
      disableTouchRipple: true
    },
    variants: [
      {
        props: { size: 'smallest' },
        style: {
          '& .MuiSvgIcon-root ': {
            fontSize: '1rem'
          }
        }
      }
    ],
    styleOverrides: {
      root: {
        marginRight: '0.25rem',
        padding: '0.25rem',
        '& .MuiSvgIcon-root ': {
          color: theme.colors.default,
          fontSize: '1.25rem'
        },
        '&:hover': {
          background: theme.palette.success.light
        },
        '&.Mui-checked': {
          '& .MuiSvgIcon-root ': {
            color: 'inherit'
          }
        }
      }
    }
  }
}

export default muiCheckbox
